import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface NotifTemplateListPayload {
  includeDeleted?: boolean;
  page?: number;
  limit?: number;
  eventType?: string;
  productId?: number;
}

export interface NotifTemplateFormPayload {
  template_code: string;
  template_name: string;
  event_type: string;
  channel?: string;
  subject: string;
  body: string;
  product_id?: number;
  status?: string;
  notes?: string;
}

const list = (payload: NotifTemplateListPayload) => {
  const { includeDeleted, page, limit, eventType, productId } = payload;
  const params: Record<string, string> = {};
  if (includeDeleted) params.includeDeleted = 'true';
  if (page) params.page = String(page);
  if (limit) params.limit = String(limit);
  if (eventType) params.eventType = eventType;
  if (productId) params.productId = String(productId);
  const query = new URLSearchParams(params).toString();
  return http.get(`${API_ENDPOINTS.masterNotifTemplates}${query ? `?${query}` : ''}`);
};

const get = (id: number | string) => http.get(`${API_ENDPOINTS.masterNotifTemplates}/${id}`);

const create = (payload: NotifTemplateFormPayload) => http.post(API_ENDPOINTS.masterNotifTemplates, payload);

const update = (id: number | string, payload: Partial<NotifTemplateFormPayload>) =>
  http.patch(`${API_ENDPOINTS.masterNotifTemplates}/${id}`, payload);

const remove = (id: number | string) => http.delete(`${API_ENDPOINTS.masterNotifTemplates}/${id}`);

const NotifTemplateService = { list, get, create, update, remove };

export default NotifTemplateService;
